import React, { useContext } from 'react'
import { Container, Box, Flex } from 'theme-ui'
import pageContextProvider from '@helpers/pageContextProvider'
import { HeaderLogo } from './Header.Logo'
import { HeaderMenu } from './Header.Menu'
import { HeaderColorMode } from './Header.ColorMode'

const styles = {
  wrapper: {
    position: `relative`,
    bg: `headerBg`
  },
  container: {
    position: `relative`,
    zIndex: 10
  },
  logoContainer: {
    flexBasis: [`auto`, `auto`, `auto`]
  },
  menuContainer: {
    flexBasis: [`auto`, `auto`, `auto`],
    minWidth: `auto`,
    order: [4, 4, `unset`]
  },
  colorModeContainer: {
    minWidth: `auto`,
    order: [2, 2, `unset`]
  }
}

export const Header = ({ children }) => {
  const context = useContext(pageContextProvider)

  const locationState =
    context.location && context.location.state && context.location.state.key

  const { darkMode } = context.pageContext

  const mobileMenu = {
      title: 'Catégories',
      items: [
      {
        name: 'Pistes de haut rendement',
        slug: '/haut-rendement/'
      },
      {
        name: 'Mes astuces de trading',
        slug:'/conseils-trading-investissement/',
      },
      {
        name: "L'univers des options",
        slug: '/strategie-options/'
      },
      {
        name: 'Option: cours et explications',
        slug: '/cours-sur-les-options/'
      }]
    };

  return (
    <Box sx={styles.wrapper}>
      <Container variant='compact' sx={styles.container}>
        <Flex variant='layout.header'>
          <Box sx={styles.logoContainer}>
            <HeaderLogo />
          </Box>
          <Box sx={styles.menuContainer}>
            <HeaderMenu locationState={locationState} mobileMenu={mobileMenu} />
          </Box>
          <Box sx={styles.colorModeContainer}>
            {darkMode && <HeaderColorMode />}
          </Box>
        </Flex>
      </Container>
      {children}
    </Box>
  )
}
